import React from 'react';
import PropTypes from 'prop-types';

import {
    FormLabel,
    InputField,
    RadioButtonInline,
    DropdownMedium,
} from 'v-c/Forms';
import {
    CascadingCheckboxContainer,
    LargeCheckbox,
} from 'v-c/Forms/Checkboxes';
import { DropdownDatepicker } from 'v-c/Widgets/Components';

import styles from './NewAuditForm.scss';

export default function NewAuditForm(props) {
    const {
        getMessage,
        hasDuplicateReportName,
        renderErrorMessage,
        fields,
        onFieldChange,
        BASE_INTL_KEY,
        typeSelection,
        shouldRenderTitle,
        shouldRenderCategories,
        datepickerProps,
        prefix,
        formatSelection,
        CATEGORIES,
    } = props;

    return (
        <>
            {shouldRenderTitle ? (
                <div>
                    <span className={styles['form-header']}>
                        {getMessage(`${BASE_INTL_KEY}.headers.form`)}
                    </span>
                    <div className={styles['form-row']}>
                        <FormLabel>
                            {getMessage(`${BASE_INTL_KEY}.headers.title`)}
                        </FormLabel>
                        <InputField
                            status={''}
                            placeholder={getMessage(`${BASE_INTL_KEY}.name.placeholder`)}
                            onChange={fields.name.onChange}
                            value={fields.name.value}
                            width={'450px'}
                        />
                        {hasDuplicateReportName(fields.name.value) &&
              renderErrorMessage('report-name', 'duplicate')}
                    </div>
                </div>
            ) : (
                <div>
                    <div className={styles['form-row']}>
                        <FormLabel>
                            {getMessage('app.reports.form.type')}
                        </FormLabel>
                        <DropdownMedium
                            id="report-type"
                            placeholder={getMessage('app.general.select')}
                            selectedId={fields.reportType.value}
                            onSelect={onFieldChange}
                            data={typeSelection}
                        />
                    </div>
                    <div className={styles['form-row']}>
                        <FormLabel>
                            {getMessage('app.reports.form.format')}
                        </FormLabel>
                        <RadioButtonInline
                            id="file-format"
                            onSelect={onFieldChange}
                            selectedId={fields.fileFormat.value}
                            data={formatSelection()}
                        />
                    </div>
                </div>
            )}
            <div className={`${styles['form-row']} ${styles['date-range']}`}>
                <FormLabel>
                    {getMessage(`${prefix}.reports.form.date_range`)}
                </FormLabel>
                <DropdownDatepicker {...datepickerProps.from} />
                <DropdownDatepicker {...datepickerProps.to} />
            </div>
            {shouldRenderCategories && (
                <div className={styles['form-row']}>
                    <FormLabel>
                        {getMessage(`${BASE_INTL_KEY}.headers.categories`)}
                    </FormLabel>
                    <CascadingCheckboxContainer maxColumns={4} idealRows={4}>
                        {CATEGORIES.map((category) => {
                            const field = fields[category];

                            return (
                                <LargeCheckbox
                                    key={category}
                                    checked={field.checked}
                                    onClick={() => field.onChange(!field.value)}
                                >
                                    {getMessage(`${BASE_INTL_KEY}.categories.${category}`)}
                                </LargeCheckbox>
                            );
                        })}
                    </CascadingCheckboxContainer>
                </div>
            )}
        </>
    );
}

NewAuditForm.propTypes = {
    getMessage: PropTypes.func.isRequired,
    hasDuplicateReportName: PropTypes.func.isRequired,
    renderErrorMessage: PropTypes.func.isRequired,
    fields: PropTypes.object.isRequired,
    onFieldChange: PropTypes.func.isRequired,
    BASE_INTL_KEY: PropTypes.string.isRequired,
    typeSelection: PropTypes.array,
    shouldRenderCategories: PropTypes.bool.isRequired,
    shouldRenderTitle: PropTypes.bool.isRequired,
    datepickerProps: PropTypes.object.isRequired,
    prefix: PropTypes.string.isRequired,
    formatSelection: PropTypes.func,
    CATEGORIES: PropTypes.array,
};

NewAuditForm.defaultProps = {
    formatSelection: () => {},
    typeSelection: [],
    CATEGORIES: [],
};
